import { CompanyRepoImpl } from "domain/repository/Company/CompanyRepoImpl";
import { CompanyTariffCodeRepoImpl } from "domain/repository/TariffCode/CompanyTariffCodeRepoImpl";
import { StandardTariffCodeRepoImpl } from "domain/repository/TariffCode/StandardTariffCodeRepoImpl";
import { TariffTypeRepoImpl } from "domain/repository/TariffCode/TariffTypeRepoImpl";
import { useTariffCodeByCompanyTracked } from "presentation/store/TariffCodeByCompany/TariffCodeByCompanyProvider";
import { TariffCodeByCompanyVM } from "presentation/viewModel/TariffCodeByCompany/TariffCodeByCompanyVM";
import { useMemo } from "react";

export const useTariffCodeByCompanyVM = () => {
    const [, setTariffCodeByCompanyState] = useTariffCodeByCompanyTracked();
    const tariffCodeByCompanyVM = useMemo(() =>
        TariffCodeByCompanyVM({
            dispatch: [setTariffCodeByCompanyState],
            companyTariffCodeRepo: CompanyTariffCodeRepoImpl(),
            standardTariffCodeRepo: StandardTariffCodeRepoImpl(),
            companyRepo: CompanyRepoImpl(),
            tariffTypeRepo: TariffTypeRepoImpl(),
        }), [setTariffCodeByCompanyState])

    return tariffCodeByCompanyVM
}

